import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteMatch, useLocation, useHistory } from 'react-router-dom';
import { History } from 'history';
import queryString from 'query-string';

import SearchFieldBig from 'packages/kakapo-ui-kit/components/forms/controls/SearchFieldBig';

const updateQueryInUrl = (value: string, currentQuery: string, path: string, history: History) => {
	// If the user was on the search page and removed everything in the search field navigate back
	if ((value == null || value === '') && path.includes('/search')) {
		history.back();
	}

	if (currentQuery !== value) {
		if (path.includes('/search')) {
			history.replace(`/search?q=${encodeURIComponent(value)}`);
		} else {
			history.push(`/search?q=${encodeURIComponent(value)}`);
		}
	}
};

const handleOnChange = (
	event: React.ChangeEvent<HTMLInputElement>,
	currentQuery: string,
	path: string,
	history: History,
) => {
	updateQueryInUrl(event.target.value, currentQuery, path, history);
};

const SearchFieldWrapper = () => {
	const { t } = useTranslation();
	const { path } = useRouteMatch();
	const history = useHistory();
	const location = useLocation();
	const currentQuery = (queryString.parse(location.search.slice(1)).q as string) ?? '';

	return (
		<SearchFieldBig
			placeholder={t('common.employeeSearchPlaceholder')}
			autoFocus={history.location.pathname.includes('/search')}
			onFocus={() => {
				if (!path.includes('/search')) {
					history.push(`/search?q=`);
				}
			}}
			onChange={(event) => handleOnChange(event, currentQuery, path, history)}
			value={currentQuery}
		/>
	);
};

export default SearchFieldWrapper;
